import React from 'react'
import { ElementProps } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import { useTheme } from '@mui/material'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
const styles = () => ({
  fieldSetFlex: { display: 'flex !important', width: '100% !important' },
  errorBorder: { borderColor: 'red' },
})
const DateField = ({
  component,
  state,
  handleChange,
  disabled = false,
  errorMessage,
}: ElementProps) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  return (
    <div className={`fieldSet ${classes.fieldSetFlex}`}>
      <FieldLabel label={component.label} required={component.required} />
      <div>
        <input
          type='date'
          value={state[component.reference] || ''}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value, component)}
          name={component.reference}
          className={errorMessage ? classes?.errorBorder : ''}
        />
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default DateField
